import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, map} from 'rxjs';
import * as _ from 'lodash';
import {ViewSettingsModel} from '../../models/view-settings.model';
import {ModelListWithCursor} from '../models/model-list-with-cursor.model';

export interface ViewSettingsPageQueryModel {
  pageName?: string;
  query?: string;
  sort?: string;
  limit?: number;
  cursor?: string;
}

type ViewSettingsListResponse = ViewSettingsModel[] | Partial<ModelListWithCursor<ViewSettingsModel>>;

@Injectable({
  providedIn: 'root'
})
export class ViewSettingsHttpService {

  private readonly baseUrl = `/viewSettings`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  /**
   * GET /viewSettings — the same call the legacy `$viewSettings` infinite scroll makes.
   */
  getPage(queryParams: ViewSettingsPageQueryModel): Observable<ModelListWithCursor<ViewSettingsModel>> {
    let params = new HttpParams();
    _.forOwn(queryParams, (value, key) => {
      if (!_.isNil(value) && value !== '') {
        params = params.set(key, value.toString());
      }
    });
    return this.http.get<ViewSettingsListResponse>(this.baseUrl, {params})
      .pipe(map((response) => this.toListWithCursor(response)));
  }

  /**
   * GET /viewSettings?ids= — the same call the legacy `$viewSettings().$asyncValues(ids)` makes.
   */
  getByIds(ids: string[]): Observable<ViewSettingsModel[]> {
    let params = new HttpParams();
    _.forEach(ids, (id) => {
      params = params.append('ids', id);
    });
    return this.http.get<ViewSettingsListResponse>(this.baseUrl, {params})
      .pipe(map((response) => this.toListWithCursor(response).list));
  }

  // The legacy persistence layer accepts both a bare array and a {list, cursor} envelope for this endpoint.
  private toListWithCursor(response: ViewSettingsListResponse): ModelListWithCursor<ViewSettingsModel> {
    if (_.isArray(response)) {
      return {list: response, cursor: null};
    }
    return {
      list: response?.list || [],
      cursor: response?.cursor || null
    };
  }
}
